// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18D3Z","content":"styles_content__2utZj","row":"styles_row__3euG0","footer":"styles_footer__2g29T","phraseLength":"styles_phraseLength__FAXCN"};